
import { defineComponent, type PropType } from 'vue'

import ActiveUserMixin from '~/mixins/activeUserMixin'
import IssueDetailMixin from '~/mixins/issueDetailMixin'

import { UiIssueLevel } from '~/utils/issue'

export default defineComponent({
  name: 'IgnoreIssueOccurrence',
  mixins: [IssueDetailMixin, ActiveUserMixin],
  emits: ['close', 'ignoreForever'],
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    filePath: {
      type: String,
      required: true
    },
    checkId: {
      type: String,
      required: false
    },
    shortcode: {
      type: String,
      required: false
    },
    issueLevel: {
      type: String as PropType<UiIssueLevel>,
      default: UiIssueLevel.Check
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    UiIssueLevel() {
      return UiIssueLevel
    },
    issueShortcode(): string {
      return this.shortcode ?? this.issue.shortcode ?? this.singleIssue.shortcode
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    async confirm(): Promise<void> {
      const params = {
        repoIssueId: this.issue.id,
        filePath: this.filePath
      } as {
        repoIssueId?: string
        checkId?: string
        filePath: string
        issueShortcode?: string
      }

      if (this.checkId) {
        delete params.repoIssueId
        params.checkId = this.checkId
        params.issueShortcode = this.issueShortcode
      }

      this.isLoading = true

      try {
        const response = await this.ignoreIssueForFile(params)

        this.$toast.success(
          `Ignored all occurrences of ${this.issueShortcode} for ${params.filePath}.`
        )
        this.$emit('ignoreForever', response.checkIssueIds)
      } catch (e) {
        this.logErrorForUser(
          e as Error,
          'Ignore Issue',
          {
            method: 'Ignore Issue Occurence for Single File',
            ...params
          },
          'Something went wrong while ignoring this issue, please contact support.'
        )
      } finally {
        this.isLoading = false
      }
    }
  }
})
